import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Transfer,
    message,
    Divider,
    Rate,
    Popover
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {CloseOutlined} from '@ant-design/icons'
import {
    StarOutlined,
    PlusCircleOutlined,
    FormOutlined,
    MobileOutlined,
    PhoneOutlined,
    WechatOutlined,
    MailOutlined,
    HomeOutlined,
    GlobalOutlined,
    FolderOpenOutlined,
    UserOutlined,
    HistoryOutlined,
    SearchOutlined,
    QrcodeOutlined
} from '@ant-design/icons'
import moment from 'moment';
import QyView from '../qiye/view'
import HtView from '../hetong/view'

const {Search} = Input;
const {Option} = Select;
const {RangePicker} = DatePicker;

class DwView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {},
            oldcondition: {},
            condition: {},
            list: [],
            count: 0,
            visible: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            that.getdata()
            that.getdata2()
        } else {
            that.setState({
                condition: {},
            })
            that.props.refresh()
        }
    }

    getdata() {
        let that = this
        let arr = {}
        arr.id = that.props.id
        fetch('/Geren/messageView', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                that.setState({
                    condition: data.data
                })
            })
    }

    getdata2 = (subtype = 0, e) => {
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, {current: 1, pagesize: old.pagesize})
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.id = that.props.id
        fetch('/Geren/msgGllist', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                //
                that.setState({
                    list: data.data,
                    tableloading: false,
                    count: Number(data.count)
                })
            })
    }

    arrfjlist(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <div key={index}>
                    <a href={item.url} download={item.name}>
                        {item.name}
                    </a>
                </div>
            )
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    pagechange(page, pagesize) {
        let that = this
        console.log(page, pagesize)
        let data = Object.assign({}, this.state.oldcondition, {current: page, pagesize: pagesize})
        setTimeout(() => {
            this.setState({
                oldcondition: data
            })
            that.getdata2(0, null)
        })
    }

    render() {
        const {tableloading} = this.state;
        const columns = [
            {
                title: '企业名称',
                dataIndex: 'name',
                key: 'name',
                width: 200,
                fixed: 'left',
                render: (row, record) => {
                    return (<>
                        <QyView id={record.id} title={row} refresh={this.getdata.bind(this)}/>
                    </>)
                },
            }, {
                title: '统一社会信用代码',
                dataIndex: 'creditCode',
                key: 'creditCode',
                width: 200,
            }, {
                title: '所属园区',
                dataIndex: 'yq_id',
                key: 'yq_id',
                width: 200,
            }, {
                title: '房间号',
                dataIndex: 'room',
                key: 'room',
                width: 120,
            }, {
                title: '合同信息',
                dataIndex: 'contract',
                key: 'contract',
                width: 150,
                render: (row, record) => {
                    return (<>
                        {row && row.length ?
                            (
                                row.map((item) =>
                                    <div key={item.id}><HtView id={item.id} title={item.name} refresh={() => {
                                    }}/></div>
                                )
                            )
                            : null}
                    </>)
                },
            }, {
                title: '欠费信息',
                dataIndex: 'qfxx',
                key: 'qfxx',
                width: 150,
                render: (row, record) => {
                    return (<>
                        <div dangerouslySetInnerHTML={{__html: row}}></div>
                    </>)
                },
            }, {
                title: '日常联系人',
                dataIndex: 'contacts',
                key: 'contacts',
                width: 120,
            }, {
                title: '日常联系人电话',
                dataIndex: 'phone',
                key: 'phone',
                width: 150,
            }, {
                title: '紧急联系人',
                dataIndex: 'emcontacts',
                key: 'emcontacts',
                width: 120,
            }, {
                title: '紧急联系人电话',
                dataIndex: 'emphone',
                key: 'emphone',
                width: 140,
            }, {
                title: '招商负责人',
                dataIndex: 'zs_fzr',
                key: 'zs_fzr',
                width: 120,
            }, {
                title: '招商部门',
                dataIndex: 'zs_bumen',
                key: 'zs_bumen',
                width: 120,
            }, {
                title: '当前状态',
                dataIndex: 'status',
                key: 'status',
                width: 100,
                fixed: 'right',
                render: (row, record) => {
                    return (<>
                        {row == 1 ? <Tag color={'green'}>{record.status_text}</Tag> : null}
                        {row == 2 ? <Tag color={'red'}>{record.status_text}</Tag> : null}
                    </>)
                },
            },
            /*{
                title: '操作',
                dataIndex: 'cz',
                key: 'cz',
                align: 'center',
                fixed: 'right',
                width: 120,
                render: (row, record) => {
                    return (<>
                        <Space>
                            <QyView id={record.id} refresh={this.getdata.bind(this)}/>
                        </Space>
                    </>)
                },
            },*/
        ]
        const columns2 = [
            {
                title: '合同编号',
                dataIndex: 'ref',
                key: 'ref',
                width: 200,
                fixed: 'left',
                render: (row, record) => {
                    return (<>
                        <HtView id={record.id} title={row} refresh={this.getdata.bind(this)}/>
                    </>)
                },
            }, {
                title: '企业名称',
                dataIndex: 'company_name',
                key: 'company_name',
                // width:200,
            }, {
                title: '所属园区',
                dataIndex: 'yq_id',
                key: 'yq_id',
                width: 150,
            }, {
                title: '租赁房间',
                dataIndex: 'room',
                key: 'room',
                width: 200,
            }, {
                title: '租赁时间',
                dataIndex: 'zltime',
                key: 'zltime',
                width: 220,
            }, {
                title: '租赁时长',
                dataIndex: 'duration',
                key: 'duration',
                width: 130,
            }, {
                title: '退租时间',
                dataIndex: 'etime',
                key: 'etime',
                width: 120,
            }, {
                title: '免租期月数',
                dataIndex: 'mz_duration',
                key: 'mz_duration',
                width: 150,
            }, {
                title: '正常期月数',
                dataIndex: 'zc_duration',
                key: 'zc_duration',
                width: 150,
            }, {
                title: '月度应收租赁费',
                dataIndex: 'rent',
                key: 'rent',
                width: 200,
            }, {
                title: '月度应收管理服务费',
                dataIndex: 'service',
                key: 'service',
                width: 200,
            }, {
                title: '采暖费',
                dataIndex: 'cncost',
                key: 'cncost',
                width: 120,
            }, {
                title: '制冷费',
                dataIndex: 'zlcost',
                key: 'zlcost',
                width: 120,
            }, {
                title: '保证金',
                dataIndex: 'guarantee',
                key: 'guarantee',
                width: 120,
            }, {
                title: '装修保证金',
                dataIndex: 'zx_guarantee',
                key: 'zx_guarantee',
                width: 150,
            }, {
                title: '添加人',
                dataIndex: 'aid',
                key: 'aid',
                width: 120,
            }, {
                title: '合同状态',
                dataIndex: 'status_text',
                key: 'status_text',
                width: 100,
                fixed: 'right',
                render: (row, record) => {
                    return (<>
                        {record.status == 1 && <Tag color={'green'}>{row}</Tag>}
                        {record.status == 2 && <Tag color={'red'}>{row}</Tag>}
                        {record.status == 3 && <Tag color={'grey'}>{row}</Tag>}
                    </>)
                },
            },
        ]
        return (
            <>
                {this.props.title ?
                    <a href='javascript:void(0)' type="link" onClick={this.mdchange.bind(this)}>{this.props.title}</a> :
                    <a href='javascript:void(0)' type="link" onClick={this.mdchange.bind(this)}>查看</a>}

                <Modal title="详情" destroyOnClose={true} bodyStyle={{padding: 15}} width={1200}
                       visible={this.state.visible} onCancel={this.mdchange.bind(this)} footer={null}>
                    <div className={'view_box'}>
                        <div className={'view_title'}>详细信息</div>
                        <div className={'view_info'}>
                            <div className={'item'}>
                                <div className={'p1'}>标题</div>
                                <div className={'p2'}>{this.state.condition.title}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>提醒时间</div>
                                <div className={'p2'}>{this.state.condition.dateline}</div>
                            </div>
                            <div className={'item all'}>
                                <div className={'p1'}>提醒内容</div>
                                <div className={'p2'}>
                                    <div dangerouslySetInnerHTML={{__html: this.state.condition.content}}></div>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.condition.type == 4 ? <>
                                <div className={'view_title'}>
                                    <div className={'p1'}>相关企业</div>
                                    <div>
                                        <Space>
                                            <Input className="input" placeholder="请输入搜索内容"
                                                   value={this.state.newcondition.keywords ? this.state.newcondition.keywords : null}
                                                   onChange={this.onChange.bind(this, 'keywords')} autoComplete="off"/>
                                            <Button type="primary" icon={<SearchOutlined/>}
                                                    onClick={this.getdata2.bind(this, 1)}>查询</Button>
                                        </Space>
                                    </div>
                                </div>
                                <Table
                                    bordered
                                    columns={columns}
                                    dataSource={this.state.list ? this.state.list : []}
                                    pagination={false}
                                    loading={tableloading}
                                    // rowSelection={rowSelection}
                                    className='table'
                                    scroll={{x: 2500}}
                                    // style={{marginBottom: 20}}
                                />
                                <Row justify={'space-between'} style={{width: '100%'}}>
                                    <div className='l'>
                                        <Space wrap>

                                        </Space>
                                    </div>
                                    <Pagination showQuickJumper
                                                current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                                                pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 10}
                                                total={this.state.count} onChange={this.pagechange.bind(this)}
                                                showSizeChanger={true}
                                                showTotal={total => `共 ${total} 条数据`}/>
                                </Row>
                            </> : null
                        }
                        {
                            this.state.condition.type == 1 ? <>
                                <div className={'view_title'}>
                                    <div className={'p1'}>相关合同</div>
                                    <div>
                                        <Space>
                                            <Input className="input" placeholder="请输入搜索内容"
                                                   value={this.state.newcondition.keywords ? this.state.newcondition.keywords : null}
                                                   onChange={this.onChange.bind(this, 'keywords')} autoComplete="off"/>
                                            <Button type="primary" icon={<SearchOutlined/>}
                                                    onClick={this.getdata2.bind(this, 1)}>查询</Button>
                                        </Space>
                                    </div>
                                </div>
                                <Table
                                    bordered
                                    columns={columns2}
                                    dataSource={this.state.list ? this.state.list : []}
                                    pagination={false}
                                    loading={tableloading}
                                    // rowSelection={rowSelection}
                                    className='table'
                                    scroll={{x: 2800}}
                                    // style={{marginBottom: 20}}
                                />
                                <Row justify={'space-between'} style={{width: '100%'}}>
                                    <div className='l'>
                                        <Space wrap>

                                        </Space>
                                    </div>
                                    <Pagination showQuickJumper
                                                current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                                                pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 10}
                                                total={this.state.count} onChange={this.pagechange.bind(this)}
                                                showSizeChanger={true}
                                                showTotal={total => `共 ${total} 条数据`}/>
                                </Row>
                            </> : null
                        }
                    </div>
                </Modal>
            </>
        )
    }
}

export default DwView
